/******Realisations******/

/***GENERAL***/
import { useState, useEffect } from "react";
import { RegexThis } from "./00-Appendix.js";

/*PAGE*/
export default function Realisations(data) {
  //Setting Page title and content according tos elected section / url
  let pageType = "";
  let pageTitle = "";

  if (window.location.href.indexOf("enseignement-numerique") != -1) {
    pageType = "num";
    pageTitle = "Enseignement numérique";
  } else if (window.location.href.indexOf("campus-augmente") != -1) {
    pageType = "campus";
    pageTitle = "Campus augmenté";
  } else if (
    window.location.href.indexOf("simplification-administrative") != -1
  ) {
    pageType = "admin";
    pageTitle = "Simplification administrative";
  }

  //Removing card anim once played for hovering animation instead
  setTimeout(() => {
    let thoses = document.getElementsByClassName("cardLink");

    for (let i in thoses) {
      let thisOne = thoses[i].classList;
      if (thisOne != undefined) {
        thisOne.add("noAnimCards");
      }
    }
  }, "2500");

  function introSpé() {
    if (pageType == "admin") {
      //console.log("coucou");
      return (
        <div className="introAdmin">
          <h2> Nîmes Université a effectué une modernisation en profondeur de ses processus administratifs, afin de fluidifier le fonctionnement interne de l’établissement et de simplifier les démarches pour les étudiants comme pour le personnel. </h2>
<ul><p>
Cette transition numérique s’est traduite par le déploiement de treize applications couvrant l’ensemble des besoins de gestion et d’accompagnement :
<li>une application auteur dédiée à l’émission et au suivi des ordres de mission ; </li>
<li>des nouveaux services numériques pour les étudiants, incluant l’inscription administrative et pédagogique en ligne, la délivrance automatisée des certificats de scolarité, la réservation d’ouvrages ou de créneaux auprès des services universitaires, ainsi que la prise de rendez-vous médicaux ou de scolarité ; </li>
<li> la revue complète des processus administratifs afin de les adapter à ces nouveaux outils et d’en garantir la cohérence globale. </li></p></ul>
<h3> Simplification et gains d’efficacité</h3>

<ul><p>
La dématérialisation des procédures a permis de réduire les tâches chronophages, d’automatiser les circuits de validation et d’améliorer la traçabilité des actes administratifs.
Les outils déployés ont notamment permis :
<li> l’usage du parapheur électronique (i-Parapheur), accélérant considérablement la circulation et la signature des documents officiels ; </li>
<li> la mise en œuvre de la solution e-Vacataire, facilitant la gestion annuelle de plus de 700 dossiers vacataires ; </li>
<li> la dématérialisation des inscriptions, certificats et attestations (BCDiplôma, coffre-fort numérique) ; </li>
<li> la réduction significative des impressions et des échanges papier, avec un impact économique et écologique positif. </li></p></ul>
<h3> Vers une administration plus connectée et plus durable</h3>
<p>Cette transformation a permis de recentrer le travail des agents sur des missions à plus forte valeur ajoutée, au service de l’accompagnement et de la réussite étudiante. </p>

<p>Un coffre-fort numérique personnel est désormais mis à disposition de chaque étudiant, permettant le dépôt sécurisé de ses relevés de notes, attestations de réussite, conventions de stage et diplômes numériques (dès leur homologation officielle). </p>




        </div>
      );
    }
  }

  //Dynamic display of cards according to selected section / url
  function displayCards(R, i) {
    if (R.type == pageType) {
      //console.log(R.hide);
      //console.log(R.link);
      if (R.hide == "n") {
        //console.log("do not hide");
        return (
          <a
            className="cardLink"
            key={R.name + i}
            //Temporarily disable link
            href={"/realisation" + "/" + RegexThis(R.name)}
          >
            <div className="cardImg">
              <img
                fetchpriority="high"
                src={"/img/real/" + R.img + ".webp"}
                alt={"Image d'illustration pour :" + " " + R.name}
              />
            </div>
            <p className="cardName">{R.name}</p>
            <p className="cardDesc">{R.desc}</p>
          </a>
        );
      } else {
        //console.log("hide");
        if (R.link != undefined && R.link != null && R.link != "") {
          return (
            <a
              className="cardLink"
              key={R.name + i}
              //Temporarily disable link
              href={R.link}
              target="_blank"
            >
              <div className="cardImg">
                <img
                  fetchpriority="high"
                  src={"/img/real/" + R.img + ".webp"}
                  alt={"Image d'illustration pour :" + " " + R.name}
                />
              </div>
              <p className="cardName">{R.name}</p>
              <p className="cardDesc">{R.desc}</p>
            </a>
          );
        } else {
          return (
            <a
              className="cardLink"
              key={R.name + i}
              //Temporarily disable link
              //href={R.link}
              //target="_blank"
            >
              <div className="cardImg">
                <img
                  fetchpriority="high"
                  src={"/img/real/" + R.img + ".webp"}
                  alt={"Image d'illustration pour :" + " " + R.name}
                />
              </div>
              <p className="cardName">{R.name}</p>
              <p className="cardDesc">{R.desc}</p>
            </a>
          );
        }
      }
    }
  }

  /*DOM*/
  return (
    <div className="homepage realisations">
      <div className="wave"></div>
      <div className="wave"></div>
      <div className="wave"></div>
      <h1>{pageTitle}</h1>
      {introSpé()}
      <div className="realWrapper">
        {data.data.map((R, i) => displayCards(R, i))}
      </div>
    </div>
  );
}
